/* eslint-disable import/no-unresolved */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef, useMemo } from "react";
import {
  Badge,
  Button,
  Combobox,
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  Input,
} from "@repo/ui";
import { Link } from "react-router-dom";
import { CirclePlus, CircleX } from "lucide-react";
import { FaAngleDown } from "react-icons/fa";
import {
  useLookupCashCenters,
  useLookupCustomers,
} from "services/lookups-mutations";
import { Paths } from "routes/paths";
import { useUser } from "hooks/use-user";
import { HasPermission } from "utils/helper";

export default function StockFilterBarV2({ getList = () => {} }) {
  const user = useUser();
  const [filters, setFilters] = useState({});
  const [selectedCashCenter, setSelectedCashCenter] = useState(
    user.CashCenterId
  );
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [filter, setFilter] = useState(null);
  const [firstLoad, setFirstLoad] = useState(true);
  const filterTimeout = useRef(null);

  const { mutate: getCashCenters, data: cashCentersList } =
    useLookupCashCenters();
  const { mutate: getCustomers, data: customersList } = useLookupCustomers();
  useEffect(() => {
    if (cashCentersList && selectedCashCenter) {
      const _cashCenter = cashCentersList.data.find(
        (elm) => elm.cashCenterId === selectedCashCenter
      );
      if (_cashCenter) {
        const _filters = {
          ...filters,
          cashCenter: `Cash Center: ${_cashCenter.name}`,
        };
        setFilters({ ..._filters });
      }
    }
  }, [cashCentersList]);
  useEffect(() => {
    getCashCenters();
    getCustomers();
  }, []);

  useEffect(() => {
    if (filter !== null) {
      filterTimeout.current = setTimeout(() => {
        getList(
          filter || "",

          selectedCashCenter || "",
          selectedCustomer || ""
        );
        handleAddFilter("filter", filter, "Search");
        clearTimeout(filterTimeout.current);
        filterTimeout.current = null;
      }, 1000);
    }
    return () => {
      if (filterTimeout.current) {
        clearTimeout(filterTimeout.current);
        filterTimeout.current = null;
      }
    };
  }, [filter]);
  useEffect(() => {
    if (!firstLoad) {
      getList(filter || "", selectedCashCenter || "", selectedCustomer || "");
    } else {
      setFirstLoad(false);
    }
  }, [selectedCashCenter, selectedCustomer]);
  const handleClearFilter = (key) => {
    const updatedFilter = { ...filters };
    delete updatedFilter[key];
    if (key === "cashCenter") {
      setSelectedCashCenter("");
    } else if (key === "customer") {
      setSelectedCustomer("");
    } else if (key === "filter") {
      setFilter("");
    }
    setFilters({ ...updatedFilter });
  };
  const handleAddFilter = (key, value, name) => {
    if (value === "") {
      handleClearFilter(key);
      return;
    }
    const updatedFilter = { ...filters };

    updatedFilter[key] = `${name}: ${value}`;
    setFilters({ ...updatedFilter });
  };
  const clearAllFilters = () => {
    let _filters = {};
    if (cashCentersList.data) {
      const _cashCenter = cashCentersList.data.find(
        (elm) => elm.cashCenterId === selectedCashCenter
      );
      if (_cashCenter) {
        _filters = {
          cashCenter: `Cash Center: ${_cashCenter.name}`,
        };
      }
    }

    setFilters(_filters);
    setSelectedCustomer("");
    setFilter("");
  };
  const canAdd = useMemo(() => {
    return HasPermission(user, "Stock", "Add");
  }, [user]);

  return (
    <>
      <div className="flex mb-3 gap-1">
        <div className="min-w-[15%] ">
          <Combobox
            placeholder="Select Cash Center"
            data={[
              ...((cashCentersList?.data || []).map((elm) => ({
                label: elm.name,
                value: elm.cashCenterId,
              })) || []),
            ]}
            value={selectedCashCenter}
            setValue={(value) => {
              setSelectedCashCenter(value);
              let name = "";
              if (value !== "") {
                name = cashCentersList?.data.filter(
                  (elm) => elm.cashCenterId === value
                )[0].name;
              }
              handleAddFilter("cashCenter", name, "Cash Center");
            }}
          />
        </div>
        <div className="min-w-[15%] ">
          <Combobox
            placeholder="Select Customer"
            data={[
              { label: "Select Customer", value: "" },
              ...((customersList?.data || []).map((elm) => ({
                label: elm.name,
                value: elm.customerId,
              })) || []),
            ]}
            value={selectedCustomer}
            setValue={(value) => {
              setSelectedCustomer(value);
              let name = "";
              if (value !== "") {
                name = customersList?.data.filter(
                  (elm) => elm.customerId === value
                )[0].name;
              }
              handleAddFilter("customer", name, "Customer");
            }}
          />
        </div>
        <div className="w-full">
          <Input
            value={filter}
            placeholder="Search: "
            title="Search: "
            onChange={(e) => {
              setFilter(e.target.value);
            }}
          />
        </div>
        {canAdd ? (
          <Button
            variant="secondary"
            className="flex-1 flex flex-row justify-end gap-0"
            style={{ padding: 0 }}
          >
            <Link to={Paths.addStock}>
              <Button variant="secondary" className="flex flex-row gap-2">
                <CirclePlus /> Add Stock
              </Button>
            </Link>{" "}
            <DropdownMenu>
              <DropdownMenuTrigger>
                <Button
                  variant="secondary"
                  style={{
                    borderLeft: "2px solid white",
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <FaAngleDown />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                <DropdownMenuItem>
                  <Link to={Paths.addStockBulk}>BulK Operations (Create)</Link>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </Button>
        ) : (
          <></>
        )}
      </div>
      <div className="flex mb-3 gap-2 flex-wrap items-end">
        {Object.entries(filters).map(([key, value]) => (
          <Badge
            variant="secondary"
            className="gap-3 pr-1 cursor-pointer"
            key={key}
          >
            {value}
            <CircleX
              onClick={() => {
                handleClearFilter(key);
              }}
            />
          </Badge>
        ))}
        {Object.keys(filters).length > 0 ? (
          <Badge variant="secondary" className="gap-3 pr-1 cursor-pointer">
            Clear All
            <CircleX
              onClick={() => {
                clearAllFilters();
              }}
            />
          </Badge>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
